module.exports = __webpack_public_path__ + "static/media/Darchviz 06.f66a9b7b.jpg";